import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-to-frame"
export default class extends Controller {
  change(event) {
    const params = new URLSearchParams(event.target.value)
    const turbo_frame_target_id = params.get("frame")
    const frame = document.getElementById(turbo_frame_target_id)

    frame.src = event.target.value
    frame.reload()
  }
}
